export default __webpack_public_path__ + "static/snorlax-e8675a98c3b6e94f8ec0446459625194.png";